<h2 mat-dialog-title>Edit Audit</h2>
<mat-dialog-content>
  <iaud-audit-edit-form [audit]="audit" (isValidChange)="toggleFormValidity($event)"></iaud-audit-edit-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button
          [disabled]="!isFormValid"
          [color]="'accent'"
          (click)="update()">Update
  </button>
</mat-dialog-actions>
